import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const GRID_PREFERRED_LANGUAGE$ = new InjectionToken<Observable<string>>('GRID_PREFERRED_LANGUAGE');
